import { DUE_WHEN_CHOICES, type DueWhenChoice } from '../constants';

interface DueWhenFilterProps {
  value: DueWhenChoice;
  onChange: (choice: DueWhenChoice) => void;
  /** Read out for the group, since the pills have no label of their own. */
  label?: string;
}

/**
 * "Any time · Overdue · Due in 7 / 15 / 30 days" — aiming a fee reminder by
 * when the fees fall due. Shared by the office's reminder dialog and the class
 * teacher's page, so both offer the same choices in the same words.
 */
export function DueWhenFilter({
  value,
  onChange,
  label = 'When the fees fall due',
}: DueWhenFilterProps) {
  return (
    <div role="group" aria-label={label} className="flex flex-wrap items-center gap-1.5">
      {DUE_WHEN_CHOICES.map((choice) => {
        const isActive = value === choice.key;
        return (
          <button
            key={choice.key}
            type="button"
            aria-pressed={isActive}
            onClick={() => onChange(choice.key)}
            className={
              isActive
                ? 'pill bg-accent-soft text-[12px] text-accent'
                : 'pill bg-surface-2 text-[12px] text-ink-2 transition-colors hover:bg-accent-soft hover:text-accent'
            }
          >
            {choice.label}
          </button>
        );
      })}
    </div>
  );
}
